(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-fabrics"]) return;
  try {
    
  if (!customElements.get('related-fabrics')) {
    customElements.define('related-fabrics', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded || this.querySelector('.related-fabrics')) return;
        this.loaded = true;
        const load = async () => {
          this.observer?.disconnect();
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = page.querySelector('related-fabrics .related-fabrics');
            if (content && this.isConnected) this.replaceChildren(content);
          } catch (_) {}
        };
        if (!('IntersectionObserver' in window)) { load(); return; }
        this.observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) load(); }, { rootMargin: '300px' });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
